import {GoingUtils} from "goingutils";


export default {
    name: "go-tree-mixins",
    computed: {},
    props: {
        openRootNode: {
            type: Boolean,
            default: true
        },
        //背景颜色
        bgColor: {
            type: String,
            default: ""
        },
        //查询后是否打开节点
        openNode: {
            type: Boolean,
            default: true
        },
        treeLoadData: {
            type: Function,
            default: null
        },
        //自定义图标信息
        icons: {
            type: String,
            default: ""
        },
        //图标类型
        iconType: {
            type: String,
            default: "common"
        },
        //是否需要查询
        hasSearch: {
            type: Boolean,
            default: false
        },
        //树头部的text文字
        headerText: {
            type: String,
            default: ""
        },
        //是否相应checkBox
        checkBox: {
            type: Boolean,
            default: false
        },
        action: {
            type: String,
            default: ""
        },
        //根据数据构建树
        data: {
            type: Array,
            default: () => {
                return [];
            }
        },
        id: {
            type: String,
            default: GoingUtils.getUUid(12)
        },
        //是否可以拖拽
        drag: {
            type: Boolean,
            default: false
        },
        //是否相应radiobox
        radioBox: {
            type: Boolean,
            default: false
        }
    },
    methods: {

    },
    mounted() {
    },
    components: {}
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlVue/mixins/goTreeMixins.js